import { PaymentMethod } from "../../enums/payment";
import { OrganizationCountry } from "../enums/country";
import { Locales } from "../enums/locales";
export function formatPaymentMethod({ locale, paymentMethod, last4, country, }) {
    if (!paymentMethod ||
        paymentMethod === PaymentMethod.Unknown ||
        paymentMethod === PaymentMethod.Manual ||
        paymentMethod === PaymentMethod.Transfer ||
        paymentMethod === PaymentMethod.Stocks ||
        paymentMethod === PaymentMethod.Pledge ||
        paymentMethod === PaymentMethod.Invoice) {
        return "";
    }
    const last4Display = last4 ? ` (••• ${last4})` : "";
    const texts = {
        daf: {
            [Locales.EN]: "Donor-advised fund (DAF)",
            [Locales.FR]: "Fonds orienté par le donateur (DAF)",
            [Locales.ES]: "Fondo asesorado por donantes (DAF)",
            [Locales.DE]: "Spenderberatener Fonds (DAF)",
        },
        card: {
            [Locales.EN]: `Card${last4Display}`,
            [Locales.FR]: `Carte${last4Display}`,
            [Locales.ES]: `Tarjeta${last4Display}`,
            [Locales.DE]: `Karte${last4Display}`,
        },
        pad: {
            [Locales.EN]: `Pre-Authorized Debit${last4Display}`,
            [Locales.FR]: `Débit préautorisé${last4Display}`,
            [Locales.ES]: `Débito preautorizado${last4Display}`,
            [Locales.DE]: `Vorab autorisierte Lastschrift${last4Display}`,
        },
        ach: {
            [Locales.EN]: `Direct Debit (ACH)${last4Display}`,
            [Locales.FR]: `Débit direct (ACH)${last4Display}`,
            [Locales.ES]: `Débito directo (ACH)${last4Display}`,
            [Locales.DE]: `Lastschrift (ACH)${last4Display}`,
        },
        sepa: {
            [Locales.EN]: `SEPA Direct Debit${last4Display}`,
            [Locales.FR]: `Prélèvement SEPA${last4Display}`,
            [Locales.ES]: `Débito directo SEPA${last4Display}`,
            [Locales.DE]: `SEPA-Lastschrift${last4Display}`,
        },
        applePayOrGooglePay: {
            [Locales.EN]: `Apple Pay / Google Pay${last4Display}`,
            [Locales.FR]: `Apple Pay / Google Pay${last4Display}`,
            [Locales.ES]: `Apple Pay / Google Pay${last4Display}`,
            [Locales.DE]: `Apple Pay / Google Pay${last4Display}`,
        },
        cash: {
            [Locales.EN]: "Cash",
            [Locales.FR]: "Comptant",
            [Locales.ES]: "Efectivo",
            [Locales.DE]: "Bargeld",
        },
        cheque: {
            [Locales.EN]: country === OrganizationCountry.UnitedStates ? "Check" : "Cheque",
            [Locales.FR]: "Chèque",
            [Locales.ES]: "Cheque",
            [Locales.DE]: "Scheck",
        },
        inKind: {
            [Locales.EN]: "In-kind",
            [Locales.FR]: "En nature",
            [Locales.ES]: "En especie",
            [Locales.DE]: "Sachleistung",
        },
        other: {
            [Locales.EN]: "Other",
            [Locales.FR]: "Autre",
            [Locales.ES]: "Otro",
            [Locales.DE]: "Sonstige",
        },
        tapToPay: {
            [Locales.EN]: "Tap to Pay",
            [Locales.FR]: "Paiement sans contact",
            [Locales.ES]: "Pago sin contacto",
            [Locales.DE]: "Kontaktlos bezahlen",
        },
        cashApp: {
            [Locales.EN]: "Cash App",
            [Locales.FR]: "Cash App",
            [Locales.ES]: "Cash App",
            [Locales.DE]: "Cash App",
        },
        paypal: {
            [Locales.EN]: "PayPal",
            [Locales.FR]: "PayPal",
            [Locales.ES]: "PayPal",
            [Locales.DE]: "PayPal",
        },
        venmo: {
            [Locales.EN]: "Venmo",
            [Locales.FR]: "Venmo",
            [Locales.ES]: "Venmo",
            [Locales.DE]: "Venmo",
        },
        free: {
            [Locales.EN]: "Free",
            [Locales.FR]: "Gratuit",
            [Locales.ES]: "Gratis",
            [Locales.DE]: "Kostenlos",
        },
        inPersonCash: {
            [Locales.EN]: "Cash (in-person)",
            [Locales.FR]: "Comptant (en personne)",
            [Locales.ES]: "Efectivo (en persona)",
            [Locales.DE]: "Bargeld (persönlich)",
        },
    };
    return texts[paymentMethod]?.[locale] || "";
}
